import * as api from '../api/prodigyai';
import {
  fetchAppraisalYearsWithStatus,
  fetchRollCorrections,
} from '@modules/appraisal/api/global';
import { fetchRollCorrections as analysisRollCorrections } from '@modules/analysis/api/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const FETCH_SELECTION_FIELDS = 'FETCH_SELECTION_FIELDS';
export const CREATE_QUERY = 'CREATE_QUERY';
export const FETCH_ALL_YEARS = 'FETCH_ALL_YEARS';
export const FETCH_ROLL_CORRECTIONS = 'FETCH_ROLL_CORRECTIONS';
export const FETCH_SAVED_QUERIES = 'FETCH_SAVED_QUERIES';
export const SAVE_QUERY = 'SAVE_QUERY';
export const DELETE_QUERY = 'DELETE_QUERY';
export const DOWNLOAD_QUERY_RESULTS = 'DOWNLOAD_QUERY_RESULTS';

export const fetchSelectionFields = makeApiActionCreatorV3(
  api.fetchSelectionFields,
  FETCH_SELECTION_FIELDS,
  `${FETCH_SELECTION_FIELDS}_SUCCESS`,
  `${FETCH_SELECTION_FIELDS}_FAILURE`,
);

export const createQuery = makeApiActionCreatorV3(
  api.createQuery,
  CREATE_QUERY,
  `${CREATE_QUERY}_SUCCESS`,
  `${CREATE_QUERY}_FAILURE`,
);

export const fetchAllYears = makeApiActionCreatorV3(
  fetchAppraisalYearsWithStatus,
  FETCH_ALL_YEARS,
  `${FETCH_ALL_YEARS}_SUCCESS`,
  `${FETCH_ALL_YEARS}_FAILURE`,
);

export const fetchQueryRollCorrections = makeApiActionCreatorV3(
  analysisRollCorrections,
  FETCH_ROLL_CORRECTIONS,
  `${FETCH_ROLL_CORRECTIONS}_SUCCESS`,
  `${FETCH_ROLL_CORRECTIONS}_FAILURE`,
);

export const fetchSavedQueries = makeApiActionCreatorV3(
  api.fetchSavedQueries,
  FETCH_SAVED_QUERIES,
  `${FETCH_SAVED_QUERIES}_SUCCESS`,
  `${FETCH_SAVED_QUERIES}_FAILURE`,
);

export const saveQuery = makeApiActionCreatorV3(
  api.saveQuery,
  SAVE_QUERY,
  `${SAVE_QUERY}_SUCCESS`,
  `${SAVE_QUERY}_FAILURE`,
);

export const deleteQuery = makeApiActionCreatorV3(
  api.deleteQuery,
  DELETE_QUERY,
  `${DELETE_QUERY}_SUCCESS`,
  `${DELETE_QUERY}_FAILURE`,
);

export const downloadQueryResults = makeApiActionCreatorV3(
  api.downloadQueryResults,
  DOWNLOAD_QUERY_RESULTS,
  `${DOWNLOAD_QUERY_RESULTS}_SUCCESS`,
  `${DOWNLOAD_QUERY_RESULTS}_FAILURE`,
);
